<!-- filepath: /Users/jaminmeyers/Documents/Websites/diligint/diligint-ui/src/views/ResetPassword.vue -->
<template>
   <div
    class="min-h-screen flex items-center justify-center
      bg-gradient-to-br from-diligint-light via-white to-diligint-dark
      dark:bg-gradient-to-br dark:from-gray-900 dark:via-gray-800 dark:to-blue-900"
  >
    <div class="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl shadow-lg p-8">
      <div class="flex flex-col items-center mb-6">
        <DiligintLogo class="h-10 w-auto text-diligint dark:text-white" />
        <h2 class="text-2xl font-bold text-diligint dark:text-white">Reset your password</h2>
        <p class="text-diligint dark:text-white text-sm mt-1 text-center">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>
      <form @submit.prevent="submit">
        <div class="mb-6">
          <label class="block text-diligint-dark dark:text-diligint-light mb-1" for="email">Email</label>
          <input
            id="email"
            v-model="email"
            type="email"
            required
            class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-diligint-dark dark:focus:ring-white bg-white dark:bg-gray-800 text-diligint-dark dark:text-white"
            placeholder="you@email.com"
            autocomplete="email"
          />
        </div>
        <button
          type="submit"
          class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-lg transition"
          :disabled="loading"
        >
          <span v-if="loading">Sending...</span>
          <span v-else>Send Reset Link</span>
        </button>
        <div v-if="message" class="mt-4 text-green-600 text-center text-sm">
          {{ message }}
        </div>
        <div v-if="error" class="mt-4 text-red-600 text-center text-sm">
          {{ error }}
        </div>
      </form>
      <div class="mt-6 text-center text-sm text-gray-500">
        <RouterLink to="/login" class="text-blue-600 hover:underline">Back to Sign In</RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import api from '@/api/axios'
import DiligintLogo from '@/assets/DiligintLogo.vue'

const email = ref('')
const loading = ref(false)
const message = ref('')
const error = ref('')

async function submit() {
  loading.value = true
  message.value = ''
  error.value = ''
  try {
    await api.post('/auth/reset-password', { email: email.value })
    message.value = 'If an account exists for this email, a reset link has been sent.'
  } catch (err) {
    error.value = err.response?.data?.error || 'Failed to send reset email.'
  } finally {
    loading.value = false
  }
}
</script>